import {
    ChannelInviteModal,
    CloseConversation,
    ConfirmationModal,
    EditCannedMessage,
    EndConversationAction,
    IdentityModalAction,
    IdentityModalTypes,
    ModalActionType,
    TransferConversationAction,
} from './types'
import {Identity} from 'api/types/properties'
import {NinchatProperties} from 'api/types'

export const endConversation = ({
    channelId, show,
}:{channelId?: string, show: boolean}): EndConversationAction => ({
    meta: {show},
    payload: {channelId},
    type: ModalActionType.END_CONVERSATION,
})

export const channelInviteModal = ({
    accessKey, show, noRedirectOnCancel,
}:{accessKey?: string, show: boolean, noRedirectOnCancel?: boolean}): ChannelInviteModal => ({
    meta: {show},
    payload: {
        accessKey,
        noRedirectOnCancel,
    },
    type: ModalActionType.CHANNEL_INVITE_MODAL,
})

export const closeConversation = ({
    channelId, show,
}:{channelId?: string, show: boolean}): CloseConversation => ({
    meta: {show},
    payload: {channelId},
    type: ModalActionType.CLOSE_CONVERSATION,
})

export const confirmationModal = ({
    onConfirm, show, text, title,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
}:{onConfirm?: any, show: boolean, text?: string, title?: string}): ConfirmationModal => ({
    meta: {show},
    payload: {
        onConfirm,
        text,
        title,
    },
    type: ModalActionType.CONFIRMATION_MODAL,
})

export const editCannedMessage = ({
    keyword, message, organization, realmId, show,
}:{keyword?: string, message?: string, organization: boolean, realmId?: NinchatProperties.RealmID, show: boolean}): EditCannedMessage => ({
    meta: {show},
    payload: {
        keyword,
        message,
        organization,
        realmId,
    },
    type: ModalActionType.EDIT_CANNED_MESSAGE,
})

export const transferConversation = ({
    show, ...context
}:{queueId?: string, channelId?: string, show: boolean}): TransferConversationAction => ({
    meta: {show},
    payload: context,
    type: ModalActionType.TRANSFER_CONVERSATION,
})

export const identityModal = ({
    identity, identityType, show,
}:{identity?: Identity, identityType?: IdentityModalTypes, show: boolean}): IdentityModalAction => ({
    meta: {show},
    payload: {
        identity,
        identityType,
    },
    type: ModalActionType.IDENTITY,
})
